import { io } from "socket.io-client";

const apiUrl = `https://roshi-chat.herokuapp.com`
// const apiUrl =`http://localhost:4000`
const setSocket = () => {
    return (apiUrl)
}
export const socketService = io(setSocket())
